import {
  InitiativeCategory,
  InitiativeMainCategory
} from '@common/enums/policy-initiative/initiative-category.enum'

export const ALL_CATEGORY_OPTIONS = [
  // Intergovernmental Categories (2) options
  {
    label:
      'AI Policy Frameworks and Initiatives (intergovernmental or supranational)',
    subLabel:
      'These include laws and regulations, conventions, declarations, recommendations, guidance, events, programmes and projects.',
    value: InitiativeCategory.IntergovernmentalPolicyFrameworks,
    parent: InitiativeMainCategory.Intergovernmental
  },
  {
    label:
      'AI Governance Bodies and Mechanisms (intergovernmental or supranational)',
    subLabel:
      'These include entities or mechanisms for co-ordinating, overseeing or implementing AI policy frameworks and initiatives.',
    value: InitiativeCategory.IntergovernmentalGovernance,
    parent: InitiativeMainCategory.Intergovernmental
  },
  // National Categories (4) options
  {
    label: 'National AI strategy',
    subLabel:
      'Official document constituting the main reference for AI policy in a country or territory.',
    value: InitiativeCategory.NationalStrategy,
    parent: InitiativeMainCategory.National
  },
  {
    label: 'AI governance bodies and mechanisms',
    subLabel:
      'These include entities or mechanisms for co-ordinating, overseeing or implementing AI policies and initiatives undertaken by countries or territories.',
    value: InitiativeCategory.NationalGovernance,
    parent: InitiativeMainCategory.National
  },
  {
    label: 'Regulations, guidelines and standards',
    subLabel:
      'These include AI-specific recommendations, guidelines, standards, and laws and regulations.',
    value: InitiativeCategory.NationalRegulations,
    parent: InitiativeMainCategory.National
  },
  {
    label: 'AI policy initiatives, programmes and projects',
    subLabel:
      'These include AI-specific policy initiatives, programmes and projects, as well as strategies and policies on AI-related topics (e.g. data, compute, digital skills).',
    value: InitiativeCategory.NationalProgrammes,
    parent: InitiativeMainCategory.National
  }
]

export function getMainCategory(
  category: InitiativeCategory
): InitiativeMainCategory {
  if (
    category === InitiativeCategory.IntergovernmentalPolicyFrameworks ||
    category === InitiativeCategory.IntergovernmentalGovernance
  ) {
    return InitiativeMainCategory.Intergovernmental
  } else {
    return InitiativeMainCategory.National
  }
}
